import { defineComponent as p, ref as m, watch as h, resolveComponent as f, createElementBlock as a, openBlock as n, normalizeClass as k, createCommentVNode as $, toDisplayString as V, Fragment as b, renderList as y, createElementVNode as _, createVNode as C } from "vue";
import { _ as v } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const g = p({
  props: {
    options: {
      type: Array,
      default: () => []
    },
    optionsValue: {
      type: Array
    },
    optionsLabel: {
      type: Function,
      default: (e) => `${e}`
    },
    inline: Boolean,
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(e, { emit: c }) {
    const t = m([]);
    return h(() => e.modelValue, (o) => {
      const r = e.optionsValue && e.optionsLabel ? e.optionsValue.map((l) => ({ value: l, label: e.optionsLabel(l) })) : e.options;
      t.value = r.map((l) => ({
        ...l,
        checked: o.indexOf(l.value) !== -1
      }));
    }, { immediate: !0 }), {
      checked: t,
      check() {
        c("update:modelValue", t.value.filter((o) => o.checked).map((o) => o.value));
      }
    };
  }
}), x = { key: 0 };
function L(e, c, t, o, r, l) {
  const s = f("t-checkbox");
  return n(), a("fieldset", {
    class: k(["tx-checkboxes", { "tx-checkboxes-inline": e.$props.inline }])
  }, [
    e.$attrs.placeholder ? (n(), a("legend", x, V(e.$attrs.placeholder), 1)) : $("", !0),
    (n(!0), a(b, null, y(e.checked, (d, i) => (n(), a("div", {
      key: `${e.$.uid}_${i}`
    }, [
      _("div", null, [
        C(s, {
          id: `${e.$.uid}_${i}`,
          modelValue: d.checked,
          "onUpdate:modelValue": (u) => d.checked = u,
          onChange: e.check,
          label: d.label
        }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange", "label"])
      ])
    ]))), 128))
  ], 2);
}
const N = /* @__PURE__ */ v(g, [["render", L]]);
export {
  N as default
};
//# sourceMappingURL=Checkboxes-CLFGhdUm.js.map
